'use strict';

var CtrlUtil = require('./CtrlUtil');
var DeferralManager = require('./DeferralsUtil');
var EventUtil = require('./EventUtil');
var MapConfig = require('./MapConfigUtil');
var MapUtil = require('./MapUtil');
var UrlUtil = require('./UrlUtil');

function UtilsProvider () {

  this.Url = UrlUtil;

  this.$get = Utils;

  function Utils ($injector, $q, $rootScope) {
    var eventUtil = new EventUtil($rootScope);

    return {
      Ctrl: CtrlUtil,
      DeferralManager: new DeferralManager($q),
      Event: eventUtil,
      MapConfig: new MapConfig(),
      Map: new MapUtil(),
      Url: UrlUtil,
    };
  }

  Utils.$inject = ['$injector', '$q', '$rootScope'];
}


module.exports = UtilsProvider;


// WEBPACK FOOTER //
// ./src/common/utils/Utils.js